import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
// 글꼴이 먼저 와야 한다. Pretendard 가변 폰트(동적 서브셋) — 굵기 45~920 이 한 벌에 있고
// 글자 조각으로 나뉘어 있어 화면에 쓰인 글자가 든 조각만 내려받는다.
import './assets/fonts/pretendard-variable/pretendard-variable.css'
import './index.css'

// body에 기본 배경색 클래스 추가
document.body.classList.add('bg-backgroundColorBg2')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

reportWebVitals()
